import {EMAIL_MAKER_COMPONENT_TYPES} from '@EmailMakerReact/email-maker-react.constants';
import {makeSliderControl} from '../../controls/slider-control/slider-control';
import {borderRadiusDescriptor, paddingDescriptor, widthDescriptor} from '../../controls/slider-control/slider-control-descriptors';
import {registerEmailMakerSectorForTypes} from '../../right-panel-registry';
import {TileComplexity} from '@EmailMakerReact/lib/email-maker-tile-meta-library.types';
import {deleteControl, duplicateControl, lockControl} from '../shared/common-action-controls';
import {borderStyleControl, conditionalBorderColorControl, conditionalBorderWidthControl} from '../shared/border-controls';
import {bgColorControl} from '../shared/color-controls';
import type {EmailMakerSectorProperty} from '../../right-panel-registry.types';

const paddingControl = makeSliderControl(paddingDescriptor);
const widthControl = makeSliderControl(widthDescriptor);
const borderRadiusControl = makeSliderControl(borderRadiusDescriptor);

const STATIC_CELL_PROPERTIES: readonly EmailMakerSectorProperty[] = [
  {control: duplicateControl},
  {control: lockControl},
  {control: deleteControl},
  {control: paddingControl, tileMeta: {icon: 'icon-edge-spacing', labelKey: 'pmwjs_spacing', complexity: TileComplexity.COMPLEX}},
  {control: bgColorControl, tileMeta: {icon: 'icon-fill', labelKey: 'pmwjs_background_color', complexity: TileComplexity.SIMPLE}},
  {control: widthControl, tileMeta: {icon: 'icon-stretch-horizontal', labelKey: 'pmwjs_width', complexity: TileComplexity.SIMPLE}},
  {control: borderRadiusControl, tileMeta: {icon: 'icon-corner', labelKey: 'pmwjs_roundness', complexity: TileComplexity.COMPLEX}},
  {control: borderStyleControl, tileMeta: {icon: 'icon-stroke', labelKey: 'pmwjs_border', complexity: TileComplexity.SIMPLE}},
  {control: conditionalBorderColorControl, tileMeta: {icon: 'icon-colorpicker', labelKey: 'pmwjs_border_color', complexity: TileComplexity.SIMPLE}},
  {control: conditionalBorderWidthControl, tileMeta: {icon: 'icon-stroke', labelKey: 'pmwjs_thickness', complexity: TileComplexity.SIMPLE}},
];

registerEmailMakerSectorForTypes([EMAIL_MAKER_COMPONENT_TYPES.table.PMW_STATIC_CELL, EMAIL_MAKER_COMPONENT_TYPES.misc.PMW_DIV], {
  title: window.i18next.t('pmwjs_static_section'),
  properties: STATIC_CELL_PROPERTIES,
});
